import { render, staticRenderFns } from "./BottomSheetFullscreen.vue?vue&type=template&id=b7e90da4&scoped=true"
import script from "./BottomSheetFullscreen.vue?vue&type=script&lang=js"
export * from "./BottomSheetFullscreen.vue?vue&type=script&lang=js"
import style0 from "./BottomSheetFullscreen.vue?vue&type=style&index=0&id=b7e90da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e90da4",
  null
  
)

export default component.exports